module.exports = __webpack_public_path__ + "media/23_Long.d38fa2de.mp3";